import { Box, CircularProgress } from "@mui/material";
import React from "react";

export default function CustomLoader({ loading }) {
  if (!loading) return null;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
